import React from 'react';
import { Link } from 'react-router-dom';
const Footer = () => {
  return <footer className="py-6 bg-white border-t border-lightgray" data-id="element-56">
      <div className="container mx-auto px-6 md:px-12" data-id="element-57">
        <div className="flex flex-col md:flex-row justify-between items-center text-sm text-black" data-id="element-58">
          <div className="mb-4 md:mb-0" data-id="element-59">
            <p data-id="element-60">© 2025 HiddenMatter LLC</p>
          </div>
          <div className="flex items-center space-x-8" data-id="element-61">
            <Link to="/terms" className="hover:underline" data-id="element-62">
              Terms
            </Link>
            <Link to="/privacy" className="hover:underline" data-id="element-63">
              Privacy
            </Link>
            <a href="https://linkedin.com" className="text-black hover:text-lime transition-colors" data-id="element-64">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-65">
                <path d="M6.94 5a2 2 0 1 1-4-.002 2 2 0 0 1 4 .002zM7 8.48H3V21h4V8.48zm6.32 0H9.34V21h3.94v-6.57c0-3.66 4.77-4 4.77 0V21H22v-7.93c0-6.17-7.06-5.94-8.72-2.91l.04-1.68z" data-id="element-66" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;